import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useBrand } from '../components/BrandProvider';

const MentionsLegalesPage = () => {
  const brand = useBrand();
  
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-brand mb-2 text-center">
              MENTIONS LÉGALES
            </h1>
            <p className="text-center text-xl text-gray-600 mb-2">
              {brand.name.toUpperCase()}
            </p>
            <p className="text-center text-sm text-gray-500 mb-8">
              Dernière mise à jour : 3 novembre 2025
            </p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              {/* Section 1 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">ÉDITEUR DU SITE</h2>
                <div className="space-y-1">
                  <p><strong>{brand.name.toUpperCase()}</strong></p>
                  <p><strong>SIRET :</strong> 380 703 256 00046</p>
                  <p><strong>Code APE :</strong> 47.91A</p>
                  <p><strong>Adresse :</strong> {brand.contact.address.street} – {brand.contact.address.postalCode} {brand.contact.address.city} – France</p>
                  <p><strong>Téléphone :</strong> {brand.contact.phone}</p>
                  <p><strong>E-mail :</strong> {brand.contact.email}</p>
                  <p><strong>Site :</strong> <a href={brand.domain} className="text-brand hover:underline">{brand.domain}</a></p>
                </div>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">DIRECTEUR DE LA PUBLICATION</h2>
                <p><strong>Directeur de la publication :</strong> Angus LECUNIL</p>
                <p><strong>Contact :</strong> {brand.contact.email}</p>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">HÉBERGEUR DU SITE</h2>
                <div className="space-y-1">
                  <p><strong>OVHcloud SAS</strong> (RCS Lille Métropole 424 761 419)</p>
                  <p><strong>Siège social :</strong> 2 rue Kellermann – 59100 Roubaix – France</p>
                  <p><strong>Téléphone (depuis la France) :</strong> 1007 / +33 9 72 10 10 07</p>
                  <p><strong>Site :</strong> <a href="https://www.ovhcloud.com" className="text-brand hover:underline" target="_blank" rel="noopener noreferrer">https://www.ovhcloud.com</a></p>
                </div>
              </section>

              {/* Section 4 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">CONTACT</h2>
                <p>Pour toute question relative au Site ou à son contenu : {brand.contact.email}</p>
                <p className="mt-2"><strong>Adresse postale :</strong> {brand.contact.address.street} – {brand.contact.address.postalCode} {brand.contact.address.city} – France</p>
              </section>

              {/* Section 5 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">PROPRIÉTÉ INTELLECTUELLE</h2>
                <p>
                  L'ensemble des éléments du Site (textes, images, graphismes, logos, marques, vidéos, icônes, architecture, bases de données, etc.) est protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation, adaptation, modification, diffusion, intégrale ou partielle, du Site ou de l'un de ses éléments, par quelque procédé que ce soit, sans autorisation écrite préalable de {brand.name.toUpperCase()}, est interdite.
                </p>
              </section>

              {/* Section 6 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">CONDITIONS D'UTILISATION</h2>
                <p>
                  L'accès et l'utilisation du Site sont réservés à un usage strictement personnel. L'utilisateur s'engage à ne pas utiliser le Site et les informations qui y figurent à des fins contraires à l'ordre public, aux bonnes mœurs ou aux droits de tiers. {brand.name.toUpperCase()} met tout en œuvre pour assurer l'exactitude et la mise à jour des informations diffusées mais ne peut garantir l'absence d'erreurs ou d'omissions ni l'accès continu au Site.
                </p>
              </section>

              {/* Section 7 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">LIENS HYPERTEXTES</h2>
                <p>
                  La mise en place de liens vers le Site est autorisée sous réserve d'identifier clairement l'origine du contenu et de ne pas porter atteinte à l'image ou aux intérêts de {brand.name.toUpperCase()}. Le Site peut proposer des liens vers des sites tiers ; {brand.name.toUpperCase()} décline toute responsabilité quant à leurs contenus ou à leurs pratiques.
                </p>
              </section>

              {/* Section 8 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">DONNÉES PERSONNELLES (RGPD)</h2>
                <div className="space-y-2">
                  <p><strong>Responsable de traitement :</strong> {brand.name.toUpperCase()} (coordonnées ci-dessus).</p>
                  <p><strong>Finalités :</strong> gestion des commandes et de la relation client, réponse aux demandes, facturation et comptabilité, sécurité du Site, mesure d'audience et prospection (si consentie).</p>
                  <p><strong>Bases légales :</strong> exécution contractuelle (commande), obligation légale (facturation/comptabilité), intérêt légitime (sécurité, amélioration du Site), consentement (prospection/cookies non essentiels).</p>
                  <p><strong>Destinataires :</strong> personnel habilité, prestataires techniques (hébergement, paiement, livraison) dans la stricte mesure nécessaire.</p>
                  <p><strong>Durées de conservation :</strong> données clients pendant la relation contractuelle puis archivage légal (notamment comptabilité : 10 ans) ; demandes de contact : jusqu'à 3 ans à compter du dernier contact ; prospection : jusqu'au retrait du consentement.</p>
                  <p><strong>Droits des personnes :</strong> accès, rectification, effacement, limitation, opposition, portabilité, et directives post-mortem. Exercice des droits : {brand.contact.email}</p>
                  <p><strong>Réclamation :</strong> CNIL (<a href="https://www.cnil.fr" className="text-brand hover:underline" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>).</p>
                  <p><strong>DPO :</strong> Angus LECUNIL</p>
                </div>
              </section>

              {/* Section 9 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">COOKIES</h2>
                <p className="mb-2">Le Site utilise des cookies et traceurs. Catégories susceptibles d'être utilisées :</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>cookies strictement nécessaires au fonctionnement et à la sécurité ;</li>
                  <li>cookies de mesure d'audience et de performance ;</li>
                  <li>cookies publicitaires et réseaux sociaux.</li>
                </ul>
                <p className="mt-2">
                  Lors de la première visite, un bandeau permet d'accepter, de refuser ou de paramétrer les cookies non essentiels. Vous pouvez modifier vos choix à tout moment via le module de gestion du consentement (« Préférences cookies ») ou votre navigateur. Pour plus d'informations, consultez la rubrique « Cookies » et/ou la Politique de confidentialité accessible depuis le Site.
                </p>
              </section>

              {/* Section 10 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">SÉCURITÉ</h2>
                <p>
                  {brand.name.toUpperCase()} met en œuvre des mesures techniques et organisationnelles appropriées (chiffrement TLS, gestion des accès, sauvegardes raisonnables) pour protéger les données contre les accès non autorisés, la perte et l'altération. L'utilisateur demeure responsable de la confidentialité de ses identifiants.
                </p>
              </section>

              {/* Section 11 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">MÉDIATION DE LA CONSOMMATION</h2>
                <p>
                  Après réclamation écrite adressée à {brand.name.toUpperCase()} et en l'absence de solution amiable, le consommateur peut recourir gratuitement à la médiation de la consommation auprès d'AME CONSO, dans un délai d'un an à compter de sa réclamation, selon les modalités indiquées sur <a href="http://www.mediationconso-ame.com" className="text-brand hover:underline" target="_blank" rel="noopener noreferrer">www.mediationconso-ame.com</a>. Plateforme européenne de RLL : <a href="https://ec.europa.eu/consumers/odr" className="text-brand hover:underline" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>
                </p>
              </section>

              {/* Section 12 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">DROIT APPLICABLE – JURIDICTION</h2>
                <p>
                  Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable ou de médiation aboutie, compétence est attribuée aux tribunaux du ressort de Draguignan, dans les conditions de droit commun.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
